import { HttpResponse, httpService } from '../core/http'
import { responseNotification } from './helpers'

export const createAccompaniments = async (payload: any): Promise<any> => {
  try {
    const httpResponse: HttpResponse = await httpService.post(
      '/accompaniments',
      payload
    )

    responseNotification({
      type: 'success',
      message: 'Sucesso',
      description: 'Acompanhamento criado com sucesso!'
    })

    return httpResponse.data
  } catch (error) {
    responseNotification({
      type: 'error',
      message: 'Erro',
      description: error.message
    })

    return error
  }
}
